<template>
  <div class="price-vertical" :class="{ highlighted: highlighted }">
    <Title class="heading" style="color: var(--text-color)">{{ title }}</Title>
    <div class="price-section heading">
      <Price
        style="color: var(--text-color); --symbol-fs: 1.5em; --price-fs: 4em; --decimal-fs: 2em"
        :price="
          isAnnually
            ? getMonthlyPriceEntire(price)
            : isMonthlyAnnualCommitment
            ? getMonthlyAnnualCommitmentEntire(price)
            : price
        "
        :decimal="
          isAnnually
            ? getMonthlyPriceDecimal(price) * 100
            : isMonthlyAnnualCommitment
            ? getMonthlyAnnualCommitmentDecimal(price)
            : null
        "
        :currency-symbol="currencySymbol"
        :period="period"
        :is-monthly-annual-commitment="isMonthlyAnnualCommitment"
      />
      <span v-if="showPreviousPrice" class="previous-price m-0">
        {{ previousPrice }}
      </span>
      <InvoiceFrequency style="color: var(--text-color)">
        <template v-if="invoiceFrequencyBold" #invoice-price> ${{ invoiceFrequencyBold }}</template>
        {{ invoiceFrequency }}
      </InvoiceFrequency>
    </div>

    <Button v-bind="commonButtonProps" @click="$emit('subscribe')">
      {{ buttonText }}
    </Button>

    <SpecsWithSubSpecs style="--primary-color: var(--specs-color)" :specs="specs" />
  </div>
</template>
<script>
import Title from '@/components/Prices/PriceAtoms/Title';
import Price from '@/components/Prices/PriceAtoms/Price';
import Button from '@/components/Prices/PriceAtoms/Button';
import SpecsWithSubSpecs from '@/components/Prices/PriceAtoms/SpecsWithSubSpecs';
import InvoiceFrequency from '@/components/Prices/PriceAtoms/InvoiceFrequency';
import {
  getMonthlyPriceEntire,
  getMonthlyPriceDecimal,
  getMonthlyAnnualCommitmentDecimal,
  getMonthlyAnnualCommitmentEntire
} from '~/utils/common.js';
export default {
  components: {
    Title,
    Price,
    Button,
    InvoiceFrequency,
    SpecsWithSubSpecs
  },
  props: {
    highlighted: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    invoiceFrequencyBold: {
      type: String,
      default: null
    },
    invoiceFrequency: {
      type: String,
      default: null
    },
    specs: {
      type: Array,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
    isButtonEnabled: {
      type: Boolean,
      required: true
    },
    isAnnually: {
      type: Boolean,
      required: true
    },
    isMonthlyAnnualCommitment: {
      type: Boolean,
      default: false
    },
    previousPrice: {
      type: String,
      default: ''
    }
  },
  computed: {
    commonButtonProps() {
      return {
        style: `
          --gradient-horizontal: var(--btn-color);
          --border: 1px solid var(--btn-border-color, transparent);
          font-weight: 600;
        `,
        buttonProps: {
          fontColor: 'var(--btn-text-color)',
          withGradient: true,
          shape: ''
        },
        highlighted: false,
        isEnabled: this.isButtonEnabled,
        fontWeight: 500
      };
    },
    showPreviousPrice() {
      return this.previousPrice && this.previousPrice !== '';
    }
  },
  methods: {
    getMonthlyPriceEntire,
    getMonthlyPriceDecimal,
    getMonthlyAnnualCommitmentDecimal,
    getMonthlyAnnualCommitmentEntire
  }
};
</script>
<style lang="scss" scoped>
.previous-price {
  text-decoration: line-through;
  font-size: 1.3em;
  color: var(--specs-color);
  margin-bottom: 0.5em;
}
.price-vertical {
  --btn-color: var(--quinary-color);
  --btn-text-color: white;
  --btn-border-color: var(--decenary-color);
  --border-color: var(--primary-color);
  --specs-color: var(--terciary-color);
  --text-color: var(--terciary-color);
  --padding: 2rem 2rem 2rem;
  --bg-color: var(--quaternary-color);

  @include lg {
    margin-right: 20px;
    margin-left: 20px;
  }

  padding: var(--padding);
  display: grid;
  justify-items: center;
  align-content: start;
  gap: 1em;
  color: var(--text-color);
  border-radius: var(--border-radius);
  background: var(--bg-color);
  border: 2px solid var(--border-color);
  box-shadow: 0px 1px 55px #00000017;
  .heading {
    --text-color: var(--secondary-color);
  }
  .price-section {
    display: grid;
    justify-items: center;
  }
  &.highlighted {
    --text-color: var(--senary-color);
    --bg-color: var(--septenary-color);
    --btn-color: var(--octonary-color);
    --btn-border-color: var(--undenary-color);

    .heading {
      --text-color: var(--senary-color);
    }
  }
  .specs {
    justify-self: start;
  }
}
</style>
